import { forwardRef, type Ref, type SVGProps } from "react";
const IconStar50PercentSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28.28 11.46 21 10.12l-3.52-6.9C17.09 2.41 16.55 2 16 2s-1.09.41-1.51 1.22L11 10.12l-7.28 1.34c-1.8.34-2.26 1.71-1 3.06l5.16 5.6-1 7.78c-.17 1.32.39 2.1 1.34 2.1a2.7 2.7 0 0 0 1.19-.33L16 26.3l6.65 3.37a2.7 2.7 0 0 0 1.19.33c.95 0 1.51-.78 1.34-2.1l-1-7.78 5.16-5.6c1.2-1.35.74-2.72-1.06-3.06m-6.26 8 1.1 8.21L16 24.05V4.69l3.68 7.21 7.94 1.48z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconStar50PercentSVG);
ForwardRef.displayName = "IconStar50Percent";
export { ForwardRef as IconStar50Percent };
